import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1d": "#FF7B00",
    "col1n": "#FF9839",
    "col2d": "#FFE000",
    "col2n": "#FFFF00"
}
function ObjMor110({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M8 2.95L0 42.6q5.35 8.85 14.2 5.15L33.5 12.2l1.1-3L9.1 0 8 2.95z"
                    id="ObjMor110__Symbol_288_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1d}
                    d="M0 .8L25.25 10l.4-.75L.15 0 0 .8z"
                    id="ObjMor110__Symbol_287_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M14.4 11.7q0-.1.05-.2l2.35-6.35L2.6 0l-2 5.55q-.05.1-.05.15l-.05.05-.25.6q-.05.1-.05.2-.8 2.5 1.9 3.95l8.3 3.05q2.7.35 4-1.85z"
                    id="ObjMor110__Symbol_286_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2d}
                    d="M.3 0L.05.6Q0 .7 0 .8l14.2 5.15q0-.1.05-.2l.2-.6L.3 0z"
                    id="ObjMor110__Symbol_285_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#ObjMor110__Symbol_288_0_Layer0_0_FILL"
                transform="translate(259.15 258.8)"
                id="ObjMor110__col1n"
            />
            <use
                xlinkHref="#ObjMor110__Symbol_287_0_Layer0_0_FILL"
                transform="translate(267 261.75)"
                id="ObjMor110__col1d"
            />
            <use
                xlinkHref="#ObjMor110__Symbol_286_0_Layer0_0_FILL"
                transform="translate(256.55 301.4)"
                id="ObjMor110__col2n"
            />
            <use
                xlinkHref="#ObjMor110__Symbol_285_0_Layer0_0_FILL"
                transform="translate(256.75 307.15)"
                id="ObjMor110__col2d"
            />
        </g></g>
    )
}
export default ObjMor110
